import React from 'react';
import { useIntl } from 'react-intl';

import { useDispatch, useSelector } from 'hooks';
import { QR_CODE_LENGTH } from 'modules/auth/constants';
import { clearCodeLoginError } from 'modules/auth/actions';
import { hasInvalidCodeError } from 'modules/auth/selectors';

const useQrCodeInput = (onValueChange: (value: string) => void) => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const hasCodeError = useSelector(hasInvalidCodeError);
  const [codeError, setCodeError] = React.useState<string>();

  const handleChange = React.useCallback((event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;

    if (hasCodeError) {
      dispatch(clearCodeLoginError());
    }

    onValueChange(value);
    if (value.length > 0 && value.length < QR_CODE_LENGTH) {
      setCodeError(intl.formatMessage(
        { id: 'login.code.tooShort', defaultMessage: 'The code must be {length} characters.' },
        { length: QR_CODE_LENGTH },
      ));
    } else {
      setCodeError(undefined);
    }
  }, [dispatch, hasCodeError, intl, onValueChange]);

  return { handleChange, codeError };
};

export default useQrCodeInput;
